export default __webpack_public_path__ + "static/media/page2.cb98bad2.png";